import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { authService } from '../../services/auth';
import logo from '../../assets/images/polopan-logo.png';

function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // If already marked logged in, go to dashboard
    if (localStorage.getItem('isLoggedIn') === 'true') {
      navigate('/dashboard');
      return;
    }

    // Parse query parameters from URL (for Google Auth callback)
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const authKey = queryParams.get('auth_key');
    const userId = queryParams.get('user_id');

    // If we have auth params from Google OAuth callback
    if (token && authKey && userId) {
      setLoading(true);
      const authParams = { token, auth_key: authKey, user_id: userId };

      // Process the Google auth response
      const success = authService.processGoogleAuthResponse(authParams);

      if (success) {
        // Fetch user profile to get email and other data
        authService.getUserProfile()
          .then(() => {
            // Clean URL by removing query parameters
            window.history.replaceState({}, document.title, '/login');
            // Navigate to dashboard
            navigate('/dashboard');
          })
          .catch(err => {
            setLoading(false);
            setError(err.message || 'Failed to get user profile');
          });
      } else {
        setLoading(false);
        setError('Invalid authentication response');
      }
      return;
    }

    // Check if user has an active session via cookie (/auth/me)
    authService.getUserProfile()
      .then(() => {
        if (localStorage.getItem('isLoggedIn') === 'true') {
          window.history.replaceState({}, document.title, '/login');
          navigate('/dashboard');
        }
      })
      .catch(() => {
        // Not logged in, stay on login screen
      });
  }, [navigate, location]);

  const handleGoogleSignIn = () => {
    setLoading(true);
    try {
      authService.initiateGoogleLogin('/dashboard');
    } catch (err) {
      setLoading(false);
      setError(err.message || 'Failed to start Google Sign In');
    }
  };

  return (
    <div className="login-container">
      <Helmet>
        <title>Login | PoloPan Admin</title>
      </Helmet>
      
      <div className="login-split">
        <div className="login-image">
          <div className="image-overlay"></div>
        </div>
        
        <div className="login-form">
          <div className="login-content">
            <div className="logo-container">
              <img src={logo} alt="PoloPan Logo" className="logo" />
            </div>
            
            <div className="premium-content">
              <h1 className="login-title">PoloPan Admin</h1>
              <p className="login-subtitle">Sign in to manage operations, orders, brands & celebrities</p>
              
              {error && <div className="error-message">{error}</div>}
              
              <div className="google-signin-container">
                <button 
                  className="google-signin-button" 
                  onClick={handleGoogleSignIn}
                  disabled={loading}
                >
                  {loading ? (
                    <span className="button-content">
                      <span className="spinner"></span>
                      <span>Redirecting to Google...</span>
                    </span>
                  ) : (
                    <span className="button-content">
                      <span>Continue with Google</span>
                    </span>
                  )}
                </button>
              </div>
            </div>
          </div>
          
          <div className="footer-text">
            <p>&copy; {new Date().getFullYear()} Rofoso Consumer Private Limited. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
